/**
 * The look the Gaps and Files read tabs share with the redesign canvas's
 * "Checks" screens (DOP-623): white 14px cards on the page's warm grey, one
 * teal for actions, and a coloured word on top of every item so the colour
 * is never the only signal.
 */

import type { ReviewKind } from "./dealScreeningReview";

export const CARD = "rounded-[14px] border border-[#e5e7eb] bg-white";

const BTN_BASE =
	"inline-flex h-11 items-center justify-center gap-2 whitespace-nowrap rounded-[10px] border px-5 text-sm font-semibold focus:outline-none focus-visible:ring-2 focus-visible:ring-[#008782] disabled:cursor-not-allowed disabled:opacity-50";

export const BTN = `${BTN_BASE} border-[#e5e7eb] bg-white text-[#1F2937] hover:border-[#c9ccd1]`;

export const BTN_PRIMARY = `${BTN_BASE} border-[#004C4B] bg-[#004C4B] text-white hover:bg-[#003a3a]`;

/** A row action inside a list: Change, Undo, History. */
export const BTN_SM =
	"inline-flex h-8 items-center whitespace-nowrap rounded-lg border border-[#e5e7eb] bg-white px-3 text-[13px] font-medium text-[#1F2937] hover:border-[#c9ccd1] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#008782] disabled:opacity-50";

/** An underlined text action: "Keep both in the memo and flag it". */
export const LINK =
	"text-[13px] font-medium text-[#004C4B] underline underline-offset-[3px] hover:text-[#003a3a] disabled:opacity-50";

export const KICKER = "text-xs font-bold uppercase tracking-[0.06em]";

/** A quoted passage, in the memo's serif so it reads as the document's words. */
export const QUOTE =
	"rounded-lg border border-[#efeee9] bg-[#fafaf8] px-3.5 py-3 font-serif text-sm leading-relaxed text-[#3f4247]";

export const INPUT =
	"w-full rounded-lg border border-[#d1d5db] bg-white px-3 py-2 text-sm text-[#111111] focus:border-[#004C4B] focus:outline-none focus:ring-1 focus:ring-[#004C4B]";

/** The word each kind of item leads with, and its colour. */
export const KIND_KICKER: Record<ReviewKind, { label: string; color: string; bar: string }> = {
	blocks: { label: "Blocks the memo", color: "text-[#b42318]", bar: "bg-[#d92d20]" },
	required: { label: "Blocks the memo", color: "text-[#b42318]", bar: "bg-[#d92d20]" },
	conflict: { label: "Two readings disagree", color: "text-[#b54708]", bar: "bg-[#f79009]" },
	stale: { label: "Look again", color: "text-[#b54708]", bar: "bg-[#f79009]" },
	gap: { label: "Not in the files", color: "text-[#b54708]", bar: "bg-[#f79009]" },
	omitted: { label: "Left out of the memo", color: "text-[#6B7280]", bar: "bg-[#c9ccd1]" },
};
